var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJet = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.23 29.37",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f2c43e;}.cls-2{fill:#254a74;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.39,29.37l13.32-3.28a.68.68,0,0,0,.5-.84L19.9,11.82A21.08,21.08,0,0,1,9.39,29.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.7,7.8.53,11.54a.7.7,0,0,0-.51.84L3.78,27.6A17.16,17.16,0,0,0,15.7,7.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.65,2.79A2.79,2.79,0,1,1,16.86,0a2.79,2.79,0,0,1,2.79,2.79"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/JET.1f823b45cbb8cc2b95b147759ec7eb8d.svg";